import React, { createContext, useState } from 'react';
import { TerminalTransaction } from 'src/common/types';

export type SelectedTransactionContextType = {
  selectedTransaction?: TerminalTransaction;
  setSelectedTransaction: React.Dispatch<React.SetStateAction<TerminalTransaction | undefined>>;
};

type SelectedTransactionContextProps = {
  children: React.ReactNode;
};

export const SelectedTransactionContext = createContext<SelectedTransactionContextType | undefined>(
  undefined,
);

export function SelectedTransactionProvider({ children }: SelectedTransactionContextProps) {
  const [selectedTransaction, setSelectedTransaction] = useState<TerminalTransaction | undefined>();

  return (
    <SelectedTransactionContext.Provider value={{ selectedTransaction, setSelectedTransaction }}>
      {children}
    </SelectedTransactionContext.Provider>
  );
}
